import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CALENDAR_X: GlameraIconDefinition = {
  name: 'calendar-x',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-calendar-x-hanger glm-calendar-x-hanger-left" pathLength="1" d="M8 2v4"></path>
    <path class="glm-calendar-x-hanger glm-calendar-x-hanger-right" pathLength="1" d="M16 2v4"></path>
    <rect class="glm-calendar-x-body" pathLength="1" width="18" height="18" x="3" y="4" rx="2"></rect>
    <path class="glm-calendar-x-header" d="M3 10h18"></path>
    <path class="glm-calendar-x-mark glm-calendar-x-mark-1" d="m14 14-4 4"></path>
    <path class="glm-calendar-x-mark glm-calendar-x-mark-2" d="m10 14 4 4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-calendar-x-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './calendar-x.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CalendarXIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CALENDAR_X;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
